import SelectAll from './select-all';

export default SelectAll;